import { compose, defaultTo, prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';
import { DASHBOARD_KEY_WINDOWS } from 'features/views/campaignDashboards/sidebar/constants';
import dashboardStructure from 'features/views/campaignDashboards/structure';

import { NAME } from './constants';

const defaultsToEmptyArray = defaultTo([]);

const getRoot = prop(NAME);

const getIdsByKewWindow = (keyWindow) => compose(defaultsToEmptyArray, prop('ids'), prop(keyWindow), getRoot);

export const getAllContacts = compose(prop('byId'), getRoot);
export const getContacts = (keyWindow) =>
	createSelector(getAllContacts, getIdsByKewWindow(keyWindow), (contacts, ids) => ids.map((id) => contacts[id]));

export const getContactIdsByDashboardsView = createSelector(
	dashboardStructure.selectors.getView,
	getRoot,
	(view, contacts) => {
		let keyWindow;
		switch (view) {
			case 'MANAGER':
				keyWindow = DASHBOARD_KEY_WINDOWS.manager;
				break;
			case 'SELLER':
				keyWindow = DASHBOARD_KEY_WINDOWS.seller;
				break;
			case 'PPZ':
				keyWindow = DASHBOARD_KEY_WINDOWS.ppz;
				break;
		}

		const correctContactsIds = propOr(EMPTY_VALUES.ARRAY, 'ids')(contacts[keyWindow]);

		return correctContactsIds;
	},
);
